import { ojs, app } from "modular-openscriptjs";
import { dom } from "../../fotastart";
import {
	monetary,
	tab,
	empty,
	oneOf,
	formatDuration,
	formatThousand,
	initials,
	either,
} from "../../helpers";

const h = app("h");
const uc = app("uc");

export function LogisticsCompanyView(company, ...args) {
	const firstArg = args[0] ?? { useSelectedFleet: false };
	const useSelectedFleet = firstArg["useSelectedFleet"] ?? false;
	const vehicleListeners = firstArg["vehicleListeners"] ?? {};
	const bodyListeners = firstArg["bodyListeners"] ?? {};
	const lcvActiveFleet = firstArg["lcvActiveFleet"] ?? true;

	let tabs = [];
	let i = 0;

	const icons = {
		bicycle: h.i({ class: "fas fa-bicycle" }),
		bike: h.i({ class: "fas fa-motorcycle" }),
		normal_car: h.i({ class: "fas fa-car-side" }),
		van: h.i({ class: "fas fa-truck" }),
	};

	const names = {
		bicycle: "Bicycle",
		bike: "Motorbike",
		normal_car: "Taxi",
		van: "Van",
	};

	let activeFleet = "bicycle";

	for (let key in icons) {
		let fee = company.delivery_fee_per_vehicle[key] ?? null;

		if (empty(fee)) continue;

		let time =
			company.delivery_times.find((item) => item.fleet_type === key)
				?.operation_time ?? null;

		let isActive = false;

		if (useSelectedFleet === true && key == uc.fleetType?.value) {
			isActive = true;
		} else if (useSelectedFleet === false && i == 0) {
			isActive = true;
		}

		if (isActive) {
			activeFleet = key;
		}

		tabs.push(
			tab(
				h.button(
					{
						class: `rounded-pill nav-link d-flex justify-content-center align-items-center ${
							isActive ? "active" : ""
						} `,
						listeners: {
							click: [
								() => (uc.fleetType.value = key),
								() => {
									if (!lcvActiveFleet) return;

									dom.get(
										`[hook="lcv-${company.id}"]`
									)?.setAttribute("lcv-active-fleet", key);
								},
							],
						},
					},
					vehicleListeners,
					h.span({ class: "d-flex" }, icons[key])
				),
				h.div(
					{ class: `tab-pane fade ${isActive ? "show active" : ""}` },
					bodyListeners,
					h.div(
						{ class: "d-flex flex-column" },
						h.div(
							{
								class: "d-flex gap-3 flex-wrap",
							},

							h.div(
								{
									class: "d-flex gap-1 align-items-center fw-700",
								},
								h.span(h.Icon("clock")),
								h.call(() => {
									if (empty(time)) {
										return h.span("As Soon As Possible");
									}

									let final = formatDuration(time);

									return h.span(final);
								})
							),

							h.div(
								{ class: "mb-0" },
								h.span(
									{ class: "fw-500" },
									monetary(fee, window.userCurrency ?? "KES")
								)
							)
						),
						h.div({ class: "text-secondary" }, h.span(names[key]))
					)
				)
			)
		);

		i++;
	}

	return h._(
		h.div(
			{
				class: "border border-3 d-flex flex-column gap-1 p-2 rounded-3",
				hook: `lcv-${company?.id}`,
			},
			either(lcvActiveFleet, { lcv_active_fleet: activeFleet }),
			h.div(
				{ class: "d-flex gap-2 flex-wrap" },
				h.span(company.name),
				either(company.rating, () =>
					h.div(
						{
							class: "d-flex gap-1 align-items-center text-secondary",
						},
						h.span(h.Icon("star")),
						h.span(oneOf(company.rating, "--"))
					)
				),
				either(company.order_count > 0, () => [
					h.span("●"),
					h.span(
						{ class: "text-secondary" },
						formatThousand(company.order_count),
						" Deliveries"
					),
				])
			),
			h.div(
				{ class: "d-flex gap-2" },

				h.div(
					bodyListeners,
					either(
						company.logo_path,
						h.Img(
							{
								loading: "lazy",
								src: company.logo_path,
							},
							{ style: "max-width: 50px;", class: "rounded" }
						),
						h.div(
							{
								class: "square-profile fw-700 bg-secondary-subtle fs-3",
							},
							{ style: "width: 50px; height: 50px" },
							initials(company.name)
						)
					)
				),
				h.div(
					{ class: "flex-fill" },
					h.Tabs({
						reversed: true,
						holders: {
							nav: h.div({
								class: "nav nav-pills",
								style: [
									"--bs-nav-link-color: black",
									"--bs-nav-pills-link-active-bg: var(--bs-gray-300)",
									"--bs-nav-pills-link-active-color: black",
									"--bs-nav-link-hover-color: var(--bs-secondary-color)",
								].join(";"),
							}),
							body: h.div({ class: "tab-content mb-2" }),
						},
						tabs: tabs,
					})
				)
			),
			...args
		)
	);
}

export default LogisticsCompanyView;
